import { defineMessages } from "react-intl";
export default defineMessages({
    temperatureByChannel: {
        id: "sensors.temperatureByChannel",
        defaultMessage: "Temperature by channel",
    },
    humidityByChannel: {
        id: "sensors.humidityByChannel",
        defaultMessage: "Humidity by channel",
    },
    compareTemperatures: {
        id: "sensors.compareTemperatures",
        defaultMessage: "Compare temperatures",
    },
    compareHumidity: {
        id: "sensors.compareHumidity",
        defaultMessage: "Compare humidity",
    },
    pm25ByChannel: {
        id: "sensors.pm25ByChannel",
        defaultMessage: "PM2.5 by channel",
    },
    aqiByChannel: {
        id: "sensors.aqiByChannel",
        defaultMessage: "AQI by channel",
    },
    comparePm25: {
        id: "sensors.comparePm25",
        defaultMessage: "Compare PM2.5",
    },
    moistureByChannel: {
        id: "sensors.moistureByChannel",
        defaultMessage: "Moisture by channel",
    },
    soilTemperatureByChannel: {
        id: "sensors.soilTemperatureByChannel",
        defaultMessage: "Soil temperature by channel",
    },
    soilConductivityByChannel: {
        id: "sensors.soilConductivityByChannel",
        defaultMessage: "Conductivity by channel",
    },
    compareMoisture: {
        id: "sensors.compareMoisture",
        defaultMessage: "Compare moisture",
    },
    leafWetnessByChannel: {
        id: "sensors.leafWetnessByChannel",
        defaultMessage: "Leaf wetness by channel",
    },
    depthByChannel: {
        id: "sensors.depthByChannel",
        defaultMessage: "Depth by channel",
    },
    indoorTemperatureAndHumidity: {
        id: "sensors.indoorTemperatureAndHumidity",
        defaultMessage: "Temperature & humidity",
    },
    indoorClimate: {
        id: "sensors.indoorClimate",
        defaultMessage: "Indoor climate",
    },
    indoorCo2Levels: {
        id: "sensors.indoorCo2Levels",
        defaultMessage: "CO2 levels",
    },
    indoorAirQualityPm: {
        id: "sensors.indoorAirQualityPm",
        defaultMessage: "PM2.5 & PM10 AQI",
    },
    sensorHistory: {
        id: "sensors.sensorHistory",
        defaultMessage: "Sensor history",
    },
    last24Hours: {
        id: "sensors.last24Hours",
        defaultMessage: "24 hours",
    },
    last7Days: {
        id: "sensors.last7Days",
        defaultMessage: "7 days",
    },
    last30Days: {
        id: "sensors.last30Days",
        defaultMessage: "30 days",
    },
    noDataAvailable: {
        id: "sensors.noDataAvailable",
        defaultMessage: "No data available",
    },
    indoorAirQuality: {
        id: "sensors.indoorAirQuality",
        defaultMessage: "Indoor Air Quality",
    },
    compareAqi: {
        id: "sensors.compareAqi",
        defaultMessage: "Compare AQI",
    },
    leafTemperatureByChannel: {
        id: "sensors.leafTemperatureByChannel",
        defaultMessage: "Leaf temperature by channel",
    },
    sensorDetailDescription: {
        id: "sensors.sensorDetailDescription",
        defaultMessage: "View historical data and trends for your sensor channels.",
    },
    selectChannel: {
        id: "sensors.selectChannel",
        defaultMessage: "Select channel",
    },
    pm25AndAqi: {
        id: "sensors.pm25AndAqi",
        defaultMessage: "PM2.5 & AQI",
    },
    pm10AndAqi: {
        id: "sensors.pm10AndAqi",
        defaultMessage: "PM10 & AQI",
    },
    pm1AndAqi: {
        id: "sensors.pm1AndAqi",
        defaultMessage: "PM1.0 & AQI",
    },
    pm4AndAqi: {
        id: "sensors.pm4AndAqi",
        defaultMessage: "PM4.0 & AQI",
    },
    bgtSensors: {
        id: "sensors.bgtSensors",
        defaultMessage: "Black globe & WBGT",
    },
    heatStressNone: {
        id: "sensors.heatStressNone",
        defaultMessage: "No heat stress",
    },
    heatStressModerate: {
        id: "sensors.heatStressModerate",
        defaultMessage: "Moderate heat stress",
    },
    heatStressStrong: {
        id: "sensors.heatStressStrong",
        defaultMessage: "Strong heat stress",
    },
    heatStressVeryStrong: {
        id: "sensors.heatStressVeryStrong",
        defaultMessage: "Very strong heat stress",
    },
    heatStressExtreme: {
        id: "sensors.heatStressExtreme",
        defaultMessage: "Extreme heat stress",
    },
    lightningSensor: {
        id: "sensors.lightningSensor",
        defaultMessage: "Lightning",
    },
    strikesToday: {
        id: "sensors.strikesToday",
        defaultMessage: "Strikes today",
    },
    cameraFeed: {
        id: "sensors.cameraFeed",
        defaultMessage: "Camera",
    },
});
